import { Column, Entity, JoinColumn, ManyToOne, PrimaryColumn } from 'typeorm';
import { Contact, FiltrableEntiteStatique } from '.';
import { Client } from './client.entity';

@FiltrableEntiteStatique<ClientContact>()
@Entity('client_contact')
export default class ClientContact {
    static non_privileged_properties: (keyof ClientContact)[] = [];
    static regular_privileged_properties: (keyof ClientContact)[] = ['client', 'contact'];
    static admin_privileged_properties: (keyof ClientContact)[] = [];
    @PrimaryColumn()
    fk_id_client: number;

    @ManyToOne(() => Client, (client) => client.id, { eager: true })
    @JoinColumn({ name: 'fk_id_client' })
    client: Client;

    @PrimaryColumn()
    fk_id_contact: number;

    @ManyToOne(() => Contact, (contact) => contact.id, { eager: true })
    @JoinColumn({ name: 'fk_id_contact' })
    contact: Contact;

    @Column({ type: 'text', nullable: true })
    poste: string;
    @Column({ nullable: true })
    debut: string;
    @Column({ nullable: true })
    fin: string;
    @Column({ name: 'b_actif', nullable: true, default: true })
    actif: boolean; // Je ne pense pas que ce soit intentionnel, contact a déjà ce champ
}
